export default __webpack_public_path__ + "static/media/icon_11_v2.af98f6a1.png";